<template>
  <div>
    <h4>Vue ReportTableAvatarIconInitial</h4>
    <p>Icon or fallback to ReportTableAvatarInitial</p>

    <div>
      <ReportTableAvatarIconInitial
        :icons="avatarIconsMap"
        icon-key="time_off"
        text="Text"
      />
      Text
    </div>
    <div>
      <ReportTableAvatarIconInitial
        :icons="avatarIconsMap"
        icon-key="na"
        text="Text"
      />
      Text
    </div>
    <div>
      <ReportTableAvatarIconInitial
        :icons="avatarIconsMap"
        icon-key="holiday"
        text="T"
      />
      Hello
    </div>
    <div>
      <ReportTableAvatarIconInitial
        :icons="avatarIconsMap"
        icon-key="na"
        text="Al"
      />
      <ReportTableAvatarIconInitial
        :icons="avatarIconsMap"
        icon-key="time_off"
        text="Text"
      />
      <ReportTableAvatarIconInitial
        :icons="avatarIconsMap"
        icon-key="holiday"
        text="Text"
      />
    </div>
  </div>
</template>
<script>
import ReportTableAvatarIconInitial from '~/components/reports/ReportTableAvatarIconInitial.vue';

export default {
  components: { ReportTableAvatarIconInitial },
  data: () => ({
    avatarIconsMap: { holiday: 'hi-gift', time_off: 'hi-time-off' },
  }),
  computed: {},
  methods: {},
};
</script>
